// REPLACE DASH IN PROMO CARD TELEPHONE NUMBER WITH NON-BREAKING HYPHEN
function swapDash() {
  var promoLinkHolder = document.querySelector('.promo-card__link--faux');

  if (promoLinkHolder != null) {
    var promoLinkText = promoLinkHolder.innerHTML;
    var promoLinkNoDash = promoLinkText.replace(/-/g, '&#8209;');

    promoLinkHolder.innerHTML = promoLinkNoDash;
  }
}

swapDash();
